import React from 'react';
import { Modal, DatePicker, Spin } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';

import AttendanceCalendar from '../share/AttendanceCalendar';

import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';

export default class StudentAttendanceRercordPage extends React.Component {
  constructor(props) {
    super(props);
    let date = new Date();
    let currentDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    this.state = {
      semester: SharedTools.getCurrentSemester(),
      currentRole: CurrentRoleStore.getCurrentRole(),
      setAttendance: false,
      editAttendance: false,
      currentDate,
      visible: false,
      loading: false,
      classes: [],
      students: {}
    }

    this.onDateChange = this.onDateChange.bind(this)
    this.showModal = this.showModal.bind(this)

  }

  componentWillReceiveProps(newProps) {
    
  }

  componentDidMount() {
    const schoolId = this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId
    this.setState({
      schoolId
    })
    if (this.state.currentRole.associatName == 'classRecord') {
      hashHistory.push(`student-attendance/schools/${schoolId}/attendance-record/classes/${this.state.currentRole.associatObj.id}`);
    } else {
      let date = new Date();
      let data = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        school_id: schoolId
      }
      this.getClassesAttendance(data)
    }

    DataService.getSchoolSetting(schoolId).then(res => {
      this.setState({
        student_default_type: res.gate_setting.student_default_type
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  getClassesAttendance(data) {
    DataService.getClassesAttendance(data).then(res => {
      this.setState({
        classes: res
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  onDateChange(day, dateString) {
    let date = new Date(dateString)
    let data = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      school_id: this.state.schoolId
    }
    this.setState({
      currentDate: dateString
    })
    this.getClassesAttendance(data)
  }

  toolStudents(students) {
    let info = '';
    let absence_count = students.filter(student => !student.sign_in && !student.has_record).length;

    students.map(student => {
      if (!student.sign_in) {
        if (student.absence_description) {
          info = info + student.full_name + ':' + student.absence_description + '，'
        } else if (this.state.student_default_type == 1 || this.state.student_default_type == 3) {
          info = info + student.full_name + ':未刷卡，'
        } else if (!student.has_record && absence_count == students.length && this.state.student_default_type == 2) {
          info = info + student.full_name + ':未提交，'
        } else {
          info = info + student.full_name + ':未到，'
        }
      }
    })

    return info.length > 0 ? info.substring(0, info.length - 1) : '';
  }

  showModal(visible, classId) {
    let date = moment(this.state.currentDate, 'YYYY-MM-DD').toDate()
    let data = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      class_id: classId
    }
    if (visible) {
      DataService.getClassDetailAttendance(data).then(res => {
        console.log(res)
        this.setState({
          students: res,
          visible
        })
      }, (error) => {
        console.log(error);
        this.setState({
          loading: false,
        })
      })
    } else {
      this.setState({
        visible
      })
    }
  }

  downloadReport(type) {
    let date = moment(this.state.currentDate, 'YYYY-MM-DD').toDate()
    let url = `http://da.ddycj.com/api/v1/clock_on_records/export_${type}_report?year=${date.getFullYear()}&month=${date.getMonth() + 1}&day=${date.getDate()}&school_id=${this.state.schoolId}`
    window.open(url);
  }

  _classAttendanceModal() {
    let students = this.state.students;
    return (
      <Modal
        title="考勤名单"
        visible={this.state.visible}
        onCancel={this.showModal.bind(this, false)}
        footer={null}
        wrapClassName="attendance-class-detail-modal"
      >
        <div className="attendance-class-detail-container">
          <div className="students-container">
            <div className="container-header">未到{students.absence ? students.absence.length : 0}人</div>
            <div className="students-list">
              {students.absence ? students.absence.map((student) => 
                <div className="student-name" key={student.id}>{student.full_name}</div>
              ) : ''}
            </div>
          </div>
          <div className="students-container">
            <div className="container-header">已到{students.on_duty ? students.on_duty.length : 0}人</div>
            <div className="students-list">
              {students.on_duty ? students.on_duty.map((student) =>
                <div className="student-name" key={student.id}>{student.full_name}</div>
              ) : ''}
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  render() {
    let classes = this.state.classes;
    let sum = classes.reduce((a, b) => {
      return a + b.absence
    }, 0);
    let date = moment(this.state.currentDate, 'YYYY-MM-DD');
    return (
      <div className="student-attendance-record-index-page">
        <div className="page-header">
          <DatePicker onChange={this.onDateChange} locale={locale} allowClear={false} defaultValue={date} placeholder="" className="date-picker-container" />
          <span className="download-btn" onClick={this.downloadReport.bind(this, 'school')}>导出{moment(date).format('YYYY.MM.DD')}考勤情况</span>
        </div>
        
        <Spin spinning={this.state.loading}>
          <div className="record-container">
            <div className="classes-list">
              <div className="class-grid">
                <div className="class-name grid-header">班级</div>
                <div className="class-name grid-header">缺勤人数</div>
                <div className="class-attendance-info grid-header">缺勤人员与原因</div>
              </div>
              {classes.map((item) => <div className="class-grid" key={item.id}>
                <div className="class-name">{item.name}</div>
                <div className="class-name">{item.students.filter(student => !student.sign_in).length}人</div>
                <div className="class-attendance-info">{this.toolStudents(item.students)}</div>
              </div>)}
              
            </div>
          </div>
        </Spin>

        {this._classAttendanceModal()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceRercordIndexPage.jsx